<template>
  <div class="sm:hidden sticky top-0 flex items-center justify-between bg-action p-4 text-action z-20 w-full">
    <div>
      <NuxtLink to="/">
        <BIcon icon="home" />
      </NuxtLink>
    </div>

    <div>
      <h3 class="font-semibold text-center">
        {{ businessName }}
      </h3>
    </div>

    <div class="flex items-center">
      <button v-if="showMenuToggle" class="bg-transparent border p-2 rounded" @click="toggleMenu">
        <BIcon icon="menu" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
const { $site } = useNuxtApp()
const layoutStore = useLayoutStore()

const businessName = computed(() => {
  if ($site.tabs.contact && $site.tabs.contact.business) {
    return $site.tabs.contact.business
  } else {
    return $site.location.title
  }
})

const active = computed({
  get () {
    return layoutStore.menu
  },
  set (val) {
    layoutStore.menu = val
  }
})

const showMenuToggle = computed(() => {
  return $site.menu?.primary || $site.tabs.user || $site.customPages?.length > 0
})

const toggleMenu = () => {
  active.value = !active.value
}
</script>
